import AngularLink from "../../../../../global/components/AngularLink/AngularLink.vue";
import SmartTable from "../../../../../global/components/table/table.vue";

import PermissionMixin from "../../../../../global/mixins/PermissionMixin";

import getTableApi from "../../../../../const/TableApis";

const TABLE_ID = "VerwendungListInStatusfunktion";

// @vue/component
export default {
  name: "VerwendungList",
  components: {
    AngularLink,
    SmartTable,
  },
  mixins: [
    PermissionMixin,
  ],
  props: {
    statusfunktion: {
      type: Object,
      required: true,
      info: "Hauptinformation",
    },
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: "",
        cols: [
          {
            label: "_LBL_STATUSFUNKTION_DETAILS_VERWENDUNG_LIST_TABLE_WORKFLOWFOLGE_",
            id: "pk",
            slot: "workflowfolge",
          },
          {
            label: "_LBL_STATUSFUNKTION_DETAILS_VERWENDUNG_LIST_TABLE_AUFGABE_",
            id: "aufgabe",
            slot: "aufgabe",
          },
          {
            label: "_LBL_STATUSFUNKTION_DETAILS_VERWENDUNG_LIST_TABLE_NACHFOLGE_AUFGABE_",
            id: "nachfolge_aufgabe",
            slot: "nachfolge_aufgabe",
          },
          {
            label: "_LBL_STATUSFUNKTION_DETAILS_VERWENDUNG_LIST_TABLE_WORKFLOW_",
            id: "workflow",
            slot: "workflow",
          },
        ],
        label: "_TXT_STATUSFUNKTION_DETAILS_VERWENDUNG_LIST_TABLE_HEADER_",
        sortable: false,
        pagination: true,
        details: false,
        urlUpdate: false,
        showHeader: false,
        showColsConfig: false,
        csvHide: true,
      },
    };
  },
  computed: {
    canViewWorkflowfolge() {
      return this.checkPermissionsSync({ perm: "workflowfolge.ui" });
    },

    canViewAufgabe() {
      return this.checkPermissionsSync({ perm: "kaufgabe.ui" });
    },

    canViewWorkflow() {
      return this.checkPermissionsSync({ perm: "workflow.ui" });
    },
  },
  created() {
    this.initUrl();
  },
  methods: {
    initUrl() {
      this.options.url = getTableApi({ id: TABLE_ID, params: { statusfunktionPk: this.statusfunktion.pk } });
    },
  },
};
